<dx-popup
  [showTitle]="true"
  [title]="dialogTitle()"
  [visible]="displayDialog()"
  (onHidden)="closeDialog()"
  [fullScreen]="true"
  [resizeEnabled]="true"
  [showCloseButton]="true">

  <dx-load-panel
    [visible]="factureResource.isLoading()"
    [showPane]="true"
    [showIndicator]="true"
    message="Chargement...">
  </dx-load-panel>

  @if (factureResource.value(); as facture) {

    <table class="facture-info-table">
      <thead>
        <tr>
          <th>Statut</th>
          <th>Rapprochement</th>
          <th>Source</th>
          <th>Référence externe</th>
          <th>Numéro</th>
          <th>Date facture</th>
          <th>Date saisie comptable</th>
          <th>Date création source</th>
          <th>Fournisseur</th>
          <th>Unité Production</th>
          @if (facture.avoirBloquant) { <th>Avoir bloquant</th> }
          @if (facture.documentNom) { <th>Document</th> }
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{{ factureStatutLabels[facture.statut] ?? facture.statut }}</td>
          <td>{{ rapprochementStatutLabels[facture.rapprochementStatut] ?? facture.rapprochementStatut }}</td>
          <td>{{ facture.source }}</td>
          <td>{{ facture.externalReference }}</td>
          <td>
            @if (facture.url) {
              <a [href]="facture.url" target="_blank" rel="noopener noreferrer">{{ facture.numero }}</a>
            } @else {
              {{ facture.numero }}
            }
          </td>
          <td>{{ facture.dateFacture | date:'dd/MM/yyyy' }}</td>
          <td>{{ facture.dateSaisieComptable | date:'dd/MM/yyyy' }}</td>
          <td>{{ facture.dateCreationSource | date:'dd/MM/yyyy HH:mm' }}</td>
          <td>{{ facture.fournisseurCode }}</td>
          <td>{{ facture.siteExterneLibelle }}</td>
          @if (facture.avoirBloquant) { <td>Oui</td> }
          @if (facture.documentNom) { <td>{{ facture.documentNom }}</td> }
        </tr>
      </tbody>
    </table>

    <table class="facture-info-table">
      <thead>
        <tr>
          <th>Montant HT</th>
          <th>Montant TTC</th>
          @if (facture.tva1Taux) { <th>TVA {{ facture.tva1Taux }}%</th> }
          @if (facture.tva2Taux) { <th>TVA {{ facture.tva2Taux }}%</th> }
          @if (facture.tva3Taux) { <th>TVA {{ facture.tva3Taux }}%</th> }
          @if (facture.tva4Taux) { <th>TVA {{ facture.tva4Taux }}%</th> }
          @if (facture.tva5Taux) { <th>TVA {{ facture.tva5Taux }}%</th> }
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{{ facture.montantHT | number:'1.2-2' }} €</td>
          <td>{{ facture.montantTTC | number:'1.2-2' }} €</td>
          @if (facture.tva1Taux) { <td>{{ facture.tva1Montant | number:'1.2-2' }} €</td> }
          @if (facture.tva2Taux) { <td>{{ facture.tva2Montant | number:'1.2-2' }} €</td> }
          @if (facture.tva3Taux) { <td>{{ facture.tva3Montant | number:'1.2-2' }} €</td> }
          @if (facture.tva4Taux) { <td>{{ facture.tva4Montant | number:'1.2-2' }} €</td> }
          @if (facture.tva5Taux) { <td>{{ facture.tva5Montant | number:'1.2-2' }} €</td> }
        </tr>
      </tbody>
    </table>

    @if (facture.rapprochementList?.length) {
      <div class="rapprochement-section">
        <div class="rapprochement-title">Rapprochements</div>
        <dx-data-grid
          [dataSource]="facture.rapprochementList"
          keyExpr="id"
          [showBorders]="true"
          [showRowLines]="true"
          [rowAlternationEnabled]="true"
          [allowColumnResizing]="true"
          columnResizingMode="widget">

          <dxi-column dataField="numeroBonLivraison" caption="N° Bon livraison"></dxi-column>
          <dxi-column dataField="dateReception" caption="Date réception" dataType="date"></dxi-column>
          <dxi-column caption="N° Facture interne" cellTemplate="numeroFactureTemplate"></dxi-column>
          <dxi-column dataField="montantHT" caption="Montant HT" dataType="number" [format]="{ type: 'currency', currency: 'EUR', precision: 2 }"></dxi-column>
          <dxi-column dataField="montantTTC" caption="Montant TTC" dataType="number" [format]="{ type: 'currency', currency: 'EUR', precision: 2 }"></dxi-column>
          @if (getRapprochementTvaTaux(facture, 1); as taux) {
            <dxi-column dataField="tva1Montant" [caption]="'TVA ' + taux + '%'" dataType="number" [format]="{ type: 'currency', currency: 'EUR', precision: 2 }"></dxi-column>
          }
          @if (getRapprochementTvaTaux(facture, 2); as taux) {
            <dxi-column dataField="tva2Montant" [caption]="'TVA ' + taux + '%'" dataType="number" [format]="{ type: 'currency', currency: 'EUR', precision: 2 }"></dxi-column>
          }
          @if (getRapprochementTvaTaux(facture, 3); as taux) {
            <dxi-column dataField="tva3Montant" [caption]="'TVA ' + taux + '%'" dataType="number" [format]="{ type: 'currency', currency: 'EUR', precision: 2 }"></dxi-column>
          }
          @if (getRapprochementTvaTaux(facture, 4); as taux) {
            <dxi-column dataField="tva4Montant" [caption]="'TVA ' + taux + '%'" dataType="number" [format]="{ type: 'currency', currency: 'EUR', precision: 2 }"></dxi-column>
          }
          @if (getRapprochementTvaTaux(facture, 5); as taux) {
            <dxi-column dataField="tva5Montant" [caption]="'TVA ' + taux + '%'" dataType="number" [format]="{ type: 'currency', currency: 'EUR', precision: 2 }"></dxi-column>
          }

          <div *dxTemplate="let cell of 'numeroFactureTemplate'">
            @if (cell.row.data.factureCommandeFournisseurId) {
              <button class="facture-interne-link" (click)="openFactureInterne(cell.row.data.factureCommandeFournisseurId)">
                {{ cell.row.data.factureCommandeFournisseurNumero }}
              </button>
            }
          </div>

          <dxo-summary>
            <dxi-total-item column="montantHT" summaryType="sum"
              [skipEmptyValues]="true" [valueFormat]="{ type: 'fixedPoint', precision: 2 }"
              displayFormat="{0} €">
            </dxi-total-item>
            <dxi-total-item column="montantTTC" summaryType="sum"
              [skipEmptyValues]="true" [valueFormat]="{ type: 'fixedPoint', precision: 2 }"
              displayFormat="{0} €">
            </dxi-total-item>
            <dxi-total-item column="tva1Montant" summaryType="sum"
              [skipEmptyValues]="true" [valueFormat]="{ type: 'fixedPoint', precision: 2 }"
              displayFormat="{0} €">
            </dxi-total-item>
            <dxi-total-item column="tva2Montant" summaryType="sum"
              [skipEmptyValues]="true" [valueFormat]="{ type: 'fixedPoint', precision: 2 }"
              displayFormat="{0} €">
            </dxi-total-item>
            <dxi-total-item column="tva3Montant" summaryType="sum"
              [skipEmptyValues]="true" [valueFormat]="{ type: 'fixedPoint', precision: 2 }"
              displayFormat="{0} €">
            </dxi-total-item>
            <dxi-total-item column="tva4Montant" summaryType="sum"
              [skipEmptyValues]="true" [valueFormat]="{ type: 'fixedPoint', precision: 2 }"
              displayFormat="{0} €">
            </dxi-total-item>
            <dxi-total-item column="tva5Montant" summaryType="sum"
              [skipEmptyValues]="true" [valueFormat]="{ type: 'fixedPoint', precision: 2 }"
              displayFormat="{0} €">
            </dxi-total-item>
          </dxo-summary>

          <dxo-scrolling mode="standard" [useNative]="true"></dxo-scrolling>
          <dxo-pager [visible]="false"></dxo-pager>
        </dx-data-grid>
      </div>
    }

    <div class="custom-button-container-right" style="margin-top: 12px;">
      @if (facture.statut === FactureExterneStatutEnum.A_TRAITER) {
        <yo-button
          iconClass="fas fa-ban"
          label="Abandonner"
          tooltip="Abandonner la facture externe"
          [theme]="ButtonThemeEnum.ERROR"
          (onClick)="abandonner()">
        </yo-button>
        <yo-button
          iconClass="fas fa-times"
          label="Refuser"
          tooltip="Refuser la facture externe"
          [theme]="ButtonThemeEnum.ERROR"
          (onClick)="refuser()">
        </yo-button>
      }
      @if (facture.rapprochementStatut === RapprochementStatutEnum.ECART) {
        <yo-button
          iconClass="fas fa-check"
          label="Valider l'écart"
          tooltip="Valider l'écart de rapprochement"
          [theme]="ButtonThemeEnum.WARNING"
          (onClick)="validerEcart()">
        </yo-button>
      } @else if ((facture.rapprochementStatut === RapprochementStatutEnum.RAPPROCHEMENT_OK || facture.rapprochementStatut === RapprochementStatutEnum.ECART_VALIDE) && !facture.avoirBloquant && (facture.statut !== FactureExterneStatutEnum.VALIDEE_AUTOMATIQUEMENT && facture.statut !== FactureExterneStatutEnum.VALIDEE_MANUELLEMENT)) {
        <yo-button
          iconClass="fas fa-check"
          label="Valider le rapprochement"
          tooltip="Valider le rapprochement"
          [theme]="ButtonThemeEnum.VALIDATE"
          (onClick)="validerRapprochement()">
        </yo-button>
      }
    </div>
  }

</dx-popup>
